import { useEffect, useMemo } from 'react';
import merge from 'deepmerge';
import { useExperiencesContext } from '../components/experiences/Experiences';
import { useRouterContext } from '../context/PlpContext';
import constants from '../utils/constants';

const DESKTOP = 'DESKTOP';
const TABLET = 'TABLET';
const MOBILE = 'MOBILE';

const getScreenSize = () => {
  if (window.matchMedia('(min-width: 768px)').matches) {
    return DESKTOP;
  }
  if (window.matchMedia('(min-width: 568px) and (max-width: 767px)').matches) {
    return TABLET;
  }
  return MOBILE;
};

const {
  PLP_CARD_SIZES: { SMALL, LARGE },
} = constants;

export const generateToggleJlData = (isLargeCardSize) => {
  const screenSize = getScreenSize();

  return {
    checked: isLargeCardSize ? 'min' : 'max',
    cardsPerCol: { [DESKTOP]: [4, 3], [TABLET]: [3, 2], [MOBILE]: [2, 1] }[
      screenSize
    ][Number(isLargeCardSize)],
  };
};

export const useShowLargeCards = (isLargeCardSizeFlagOn) => {
  return isLargeCardSizeFlagOn;
};

export const useProductCardSize = () => {
  const router = useRouterContext();
  const {
    isProductCardSizeOverrideOn,
    isProductCardSizeFlagOn,
    isLargeCardSizeFlagOn,
  } = useExperiencesContext();

  const {
    query: { cardSize, type, facetId, ...queryRest },
    asPath,
    pathname,
  } = router;

  const isLargeCardSize =
    (isProductCardSizeFlagOn && !cardSize) || // no cardSize query param defined, large by default
    (isProductCardSizeFlagOn && cardSize === LARGE) || // cardSize query param explicitly "large"
    useShowLargeCards(isLargeCardSizeFlagOn) ||
    isProductCardSizeOverrideOn;

  const value = useMemo(() => {
    const largeCardUrl = {
      as: {
        pathname: asPath.split('?')[0],
        query: { ...queryRest, cardSize: LARGE },
      },
      href: {
        pathname,
        query: { ...queryRest, type, facetId, cardSize: LARGE },
      },
    };
    const standardCardUrl = {
      as: {
        pathname: asPath.split('?')[0],
        query: { ...queryRest, cardSize: SMALL },
      },
      href: {
        pathname,
        query: { ...queryRest, type, facetId, cardSize: SMALL },
      },
    };
    const colsPerProductCard = {
      checked: isLargeCardSize ? 'largeSize' : 'normalSize',
    };

    return {
      largeCardUrl,
      standardCardUrl,
      isLargeCardSize,
      colsPerProductCard,
    };
  }, [asPath, queryRest, pathname, facetId, type, isLargeCardSize]);

  useEffect(() => {
    const detail = generateToggleJlData(isLargeCardSize);

    window.jlData = merge(window.jlData, {
      page: {
        productPages: {
          productCardView: detail,
        },
      },
    });
  }, [isLargeCardSize]);

  return value;
};
